import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { STORE_PROMOTION_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getStorePromotionSettingAction = createAsyncThunk(
    'price/getStorePromotionSettingAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ STORE_PROMOTION_SETTINGS_PATH }/${ data.type }/${ data.podId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getStorePromotionSettingSlice = createSlice({
    name: 'getStorePromotionSettingSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(getStorePromotionSettingAction.pending, () => STATE__API__STARTED);
        builder.addCase(getStorePromotionSettingAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getStorePromotionSettingAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getStorePromotionSettingState = (state) => state.price.getStorePromotionSetting;
export default getStorePromotionSettingSlice.reducer;